import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _isEmpty from "lodash/isEmpty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GENOME_FILE_UPDATE, GENOME_FILE_CREATED } from 'redux/actionTypes/genomes';
var genomeFileStateReducer = produce(function (draft, action) {
  var _draft$custom$genomeI, _draft$custom$genomeI3;
  var _action$payload = action.payload,
    fileId = _action$payload.fileId,
    genomeId = _action$payload.genomeId,
    diff = _action$payload.diff;

  // this race condition is avoided when a file is deleted while an upload is in progress
  if (action.type === GENOME_FILE_UPDATE && _isEmpty((_draft$custom$genomeI = draft.custom[genomeId]) === null || _draft$custom$genomeI === void 0 ? void 0 : _draft$custom$genomeI.files[fileId])) {
    return;
  }
  if (action.type === GENOME_FILE_CREATED) {
    var _draft$custom$genomeI2;
    if (!((_draft$custom$genomeI2 = draft.custom[genomeId]) !== null && _draft$custom$genomeI2 !== void 0 && _draft$custom$genomeI2.files)) {
      draft.custom[genomeId].files = {};
    }
    draft.custom[genomeId].files[fileId] = {};
  }
  draft.custom[genomeId].files[fileId] = _objectSpread(_objectSpread(_objectSpread({}, draft.custom[genomeId].files[fileId]), diff), {}, {
    upload: _objectSpread(_objectSpread({}, (_draft$custom$genomeI3 = draft.custom[genomeId].files[fileId]) === null || _draft$custom$genomeI3 === void 0 ? void 0 : _draft$custom$genomeI3.upload), diff.upload)
  });
});
export default genomeFileStateReducer;